export default __webpack_public_path__ + "static/media/open_eye_icon.8e0710f0.svg";